import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { IPackageListingAppState } from '../redux-state';

import { IPackageListingAppText } from '../custom/classes/package-listing-text';

import LoaderView from '../views/library/loader.view';

interface IExternalProps {
}

interface StateToProps {
    text: IPackageListingAppText;
    isProcessing: boolean;
}

interface DispatchToProps {
}

export type LoaderProps = IExternalProps & StateToProps;

export const LoaderBase: React.StatelessComponent<LoaderProps> = props => {
    return (
        <LoaderView {...props} />
    )
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IExternalProps): StateToProps {
    return {
        text: state.packageListingText,
        isProcessing: state.packageListing.processing
    }
}

export default connect(mapStateToProps)(LoaderBase);